import { render, staticRenderFns } from "./AwardsPreview.vue?vue&type=template&id=3541a3ea"
import script from "./AwardsPreview.vue?vue&type=script&lang=js"
export * from "./AwardsPreview.vue?vue&type=script&lang=js"
import style0 from "./AwardsPreview.vue?vue&type=style&index=0&id=3541a3ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports